import { TApplicationState } from '../../types/redux';
import { selectFilters } from './selectFilters';

export const selectFlatFormValues = (state: TApplicationState) => {
  const filters = selectFilters(state);

  return {
    houseId: filters.houseId,
    area: filters.area,
    roomsCount: filters.roomsCount,
    flatNumber: filters.flatNumber ? String(filters.flatNumber) : undefined,
  };
};
